// extracted by mini-css-extract-plugin
export default {"resultado":"Recibo_resultado__PcjH6"};